import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
  width: string;
  height: string;
  text: string;
  onClick: () => void;
  sx?: any;
  disabled?: boolean;
}

export const ContainedRedButton: React.FC<Props> = ({
  width,
  height,
  text,
  onClick,
  sx,
  disabled,
}) => {
  return (
    <PrimaryButton
      style={sx}
      width={width}
      height={height}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </PrimaryButton>
  );
};

interface PrimaryButtonProps {
  width: string;
  height: string;
  disabled?: boolean;
}

const PrimaryButton = styled.button<PrimaryButtonProps>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background: ${(props) =>
    props.disabled
      ? theme.palette.primitives.gray200
      : theme.palette.primitives.red500};
  border: ${(props) =>
    props.disabled ? `none` : `1px solid ${theme.palette.primitives.red500}`};
  border-radius: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: ${theme.palette.primitives.white};
  cursor: ${(props) => (props.disabled ? `not-allowed` : `pointer`)};
`;
